import { DistributionChainState } from '@next/core-lib/cart';
import { TableColumn, TableColumnTypes } from '@next/core-lib/table';
import { CartColumns } from 'src/app/cart/models/app.models';

import { CartComponent } from '../../cart.component';

export const createPreSalesOrderColumns = (componentRef: CartComponent, hasAtLeastAdvisorRole: boolean): TableColumn[] => {
  const preSalesColumns: TableColumn[] = [
    {
      id: CartColumns.skuTitle,
      type: TableColumnTypes.TEMPLATE,
      label: `cart.cart-column-${CartColumns.skuTitle}`,
      template: componentRef.columnSkuTitleRef.instance.template,
      className: 'flex__child--2',
      headerClassName: 'flex__child--2',
      disableSort: true,
    },
    {
      id: CartColumns.quantityAndUnitInformation,
      type: TableColumnTypes.TEMPLATE,
      label: `cart.cart-column-${CartColumns.quantityAndUnitInformation}`,
      template: componentRef.columnQuantityAndUnitInformationRef.instance.template,
      className: 'flex__child--2',
      headerClassName: 'flex__child--2',
      disableSort: true,
    },
    {
      id: CartColumns.siloDistribution,
      type: TableColumnTypes.TEMPLATE,
      label: `cart.cart-column-${CartColumns.siloDistribution}`,
      template: componentRef.columnSiloDistributionRef.instance.template,
      className: 'flex__child--2',
      headerClassName: 'flex__child--2',
      disableSort: true,
    },
    {
      id: CartColumns.deliveryPeriod,
      type: TableColumnTypes.TEMPLATE,
      label: `cart.cart-column-${CartColumns.deliveryPeriod}`,
      template: componentRef.columnDeliveryPeriodRef.instance.template,
      className: 'flex__child--2',
      headerClassName: 'flex__child--2',
      disableSort: true,
    },
  ];

  if (
    componentRef.cart.lines.some(
      (line) =>
        line.orderingInformation.distributionChainState === DistributionChainState.BlockedForReturn ||
        line.orderingInformation.distributionChainState === DistributionChainState.TemporaryReturnBlockWebshop,
    )
  ) {
    preSalesColumns.push({
      id: CartColumns.blockedForReturn,
      type: TableColumnTypes.TEMPLATE,
      label: '' /* Intentionally empty */,
      template: componentRef.columnBlockedForReturnRef.instance.template,
      className: 'flex__child--2',
      headerClassName: 'flex__child--2',
      disableSort: true,
    });
  }

  if (hasAtLeastAdvisorRole && componentRef.showPrice) {
    preSalesColumns.push({
      id: CartColumns.priceResults,
      type: TableColumnTypes.TEMPLATE,
      label: `cart.cart-column-${CartColumns.priceResults}`,
      template: componentRef.columnPriceResultsRef.instance.template,
      disableSort: true,
    });
  }

  return preSalesColumns;
};
